import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import tickIcon from "../../assets/img/green-bg-tick.svg";
import logo from "../../assets/img/htrader-logo.png";
import "./LoggedOut.css";

const LoggedOut = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Replacing current state so "Back" doesn't go back to protected page
        window.history.pushState(null, "", window.location.href);

        const handlePopState = () => {
            navigate("/auth", { replace: true });
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [navigate]);

    return (
        <div className="loggedout-outer">
            <div className="loggedout-box">
                <button
                    className="loggedout-logo-btn"
                    onClick={() => navigate("/")}
                    aria-label="Go to home"
                >
                    <img src={logo} alt="Logo" className="loggedout-logo" />
                </button>
                <div className="loggedout-gap" />
                <img src={tickIcon} alt="Success" className="loggedout-tick" />
                <p className="loggedout-message">
                    You have been successfully logged out.
                </p>
                <button
                    className="loggedout-signin-btn"
                    onClick={() => navigate("/auth")}
                >
                    Sign in again
                </button>
            </div>
        </div>
    );
};

export default LoggedOut;
